module.exports = __webpack_public_path__ + "img/default.7d70802f.png";